import { DEFAULT_FONT_SIZE_IN_PIXELS } from "../constants";
export var getRem = function getRem(fontSize) {
  return "".concat(parseFloat(fontSize, 10) / DEFAULT_FONT_SIZE_IN_PIXELS, "rem");
};